<template>
    <transition name="meassage-anime">
        <div class="messagePanel" v-if="isShow" @mouseenter="stopCountDown()" @mouseleave="startCountDown()">
            <h1>{{text}}</h1>
            <span :style="'width:'+leavePre+'%'"></span>
        </div>
    </transition>
</template>
<script>
export default {
    name:'messageBox',
    props:{
        initText:{
            type:String,
            required:true
        }
    },data(){
        return{
            text:this.initText,
            isShow:true,
            leavePre:100,
            count:0,
            countDown:undefined,
            leaveTime:3000
        }
    },
    methods:{
        stopCountDown(){
            if(this.countDown){
                clearInterval(this.countDown);
            }
        },
        startCountDown(){
            this.countDown=setInterval(() => {
                this.count+=10;
                if (this.count>=this.leaveTime) {
                    this.leavePre=0;
                    this.stopCountDown();
                    setTimeout(() => {
                        this.isShow=false;
                    }, 600);
                }
                this.leavePre=(1-(this.count/this.leaveTime))*100
            }, 10);
        }
    }
    ,created() {
        this.leaveTime+=this.text.length*400;
        if (this.leaveTime>=5000) {
            this.leaveTime=5000;
        }
        this.startCountDown();
    }
}
</script>
<style lang="scss">
    .messagePanel{
        position:relative;
        border:1px #999 solid;
        background-color:#111;
        z-index:9999;
        padding:20px;
        font-size:.8rem;
        color:#fff;
        overflow:hidden;
        max-width:20rem;
        margin:10px 0;
        word-wrap:normal;
        animation:messageIn 1s;
        h1{
            padding:0;
            margin:0;
            overflow:hidden;word-wrap:normal;
            text-overflow:ellipsis
        }
        span{
            position:absolute;
            bottom:0;
            left:0;
            width:100%;
            height:5px;
            background-color:#2bf;
            transition:default;
        }
    }
    @keyframes messageIn{
        0%{
            transform:translateX(120%)
        }
        100%{
            transform:translateX(0%)
        }
    }
    .meassage-anime-enter-active {
        transition: all 1s ease-out;
    }

    .meassage-anime-leave-active {
        transition: all 1s ease-in ,height 1s 1s ease-in  ,padding 1s 1s ease-in,margin 1s 1s ease-in;
    }

    .meassage-anime-leave-to {
        transform: translateX(-100%);
        opacity: 0;
        padding:0;
        margin:0;
    }
    .meassage-anime-enter-from{
        transform: translateX(100%);
        opacity: 0;
    }
    .meassage-anime-enter-to,
    .meassage-anime-leave-from {
        transform: translateX(0);
        margin:10px 0;
    }
</style>